import type { UpdateInstanceDto } from '@plugins/faq-lib/types';

export class LoadInstance {
  static readonly type = '[Instance] Load instance';
}

export class UpdateInstance {
  static readonly type = '[Instance] Update instance';
  constructor(public instanceChanges: UpdateInstanceDto) {}
}

export class CountByStatus {
  static readonly type = '[Instance] Get number of questions by status';
}
